import React from 'react';
// Source: Unsplash (free to use under the Unsplash License), photo by
// Katarzyna Zygnerska — https://unsplash.com/photos/nCM_pxDDp0U
import heroImage from "../assests/hero-orthodontic-models.jpg";
// Link is only used by the commented-out "View Offers" button below (Offers
// page is disabled for now — see routes/index.js). Kept imported there in a
// comment rather than removed, so re-enabling it later is a one-line
// uncomment, not a re-import.
import { ArrowRight, ShieldCheck, Package, Headphones } from 'lucide-react';

const trustPoints = [
  { icon: ShieldCheck, title: "Genuine Products", desc: "Trusted orthodontic supplies" },
  { icon: Package, title: "Wide Product Range", desc: "Everything you need in one place" },
  { icon: Headphones, title: "Reliable Support", desc: "Here to help you" },
];

const Banner = () => {
  return (
    <div className="w-full max-w-screen-xl mx-auto py-6 px-4 sm:px-6">
      <div className="rounded-2xl bg-gradient-to-br from-indigo-50 via-white to-blue-50 shadow-sm px-5 py-8 sm:px-8 md:px-12 md:py-10">
        <div className="grid md:grid-cols-2 items-center gap-8 md:gap-10">
          {/* Text Section */}
          <div>
            <span className="inline-block text-xs sm:text-sm font-semibold tracking-wide uppercase text-[#0094DA] mb-3">
              Orthodontic Supplies
            </span>
            <h1 className="!leading-[1.1] text-2xl sm:text-3xl lg:text-[2.75rem] font-bold text-gray-800 mb-4">
              Quality Orthodontic Products for <br></br><span className="text-[#2D3092]">Better Smiles</span>
            </h1>
            <p className="text-gray-600 mb-6 text-base sm:text-lg font-semibold max-w-md">
              Brackets, wires, bands, tubes, instruments &amp; more — all in one place
            </p>
            <div className="flex flex-wrap items-center gap-3">
              <a
                href="#products"
                className="no-underline inline-flex items-center gap-2 bg-[#2D3092] hover:bg-indigo-700 text-white font-semibold px-6 py-3 rounded-full transition"
              >
                Shop Products <ArrowRight size={18} />
              </a>
              {/* Offers page is disabled for now — see routes/index.js.
              <Link
                to="/offers"
                className="no-underline inline-flex items-center gap-2 bg-white border border-gray-200 hover:border-[#2D3092] text-gray-700 hover:text-[#2D3092] font-semibold px-6 py-3 rounded-full transition"
              >
                View Offers
              </Link>
              */}
            </div>
          </div>

          {/* Image Section */}
          <div className="w-full h-56 sm:h-64 md:h-72 lg:h-80">
            <img
              src={heroImage}
              alt="Orthodontic brackets and dental models"
              className="h-full w-full object-cover rounded-xl shadow-sm"
            />
          </div>
        </div>

        {/* Trust row */}
        <div className="mt-6 sm:mt-8 pt-5 border-t border-gray-100 grid grid-cols-3 gap-3 sm:gap-6">
          {trustPoints.map((point, idx) => {
            const Icon = point.icon;
            return (
              <div key={idx} className="flex flex-col sm:flex-row items-center sm:items-center gap-1 sm:gap-3 text-center sm:text-left">
                <div className="flex-shrink-0 w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-white flex items-center justify-center text-[#2D3092] shadow-sm">
                  <Icon size={34} strokeWidth={2} />
                </div>
                <div>
                  <p className="text-base sm:text-base font-semibold text-gray-800 leading-tight">{point.title}</p>
                  <p className="hidden sm:block text-base text-gray-700 leading-tight">{point.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Banner;
